import React, { Component, Suspense } from 'react';
import { observer, inject } from 'mobx-react';
// import Login from '../Login';
// import Loading from '../Loading';
import MainScreen from '../MainScreen';
import cssVars from 'css-vars-ponyfill';
import welcomeShopImage from 'assets/welcome_bg_top.png';
import NoInternetModal from '../MainScreen/AppBody/NoInternetModal';

const StoresScreen = React.lazy(() => import('Components/StoresScreen'));
const ToskanaStoresScreen = React.lazy(()=> import('Components/ToskanaStoresScreen'));
const ScootyStoresScreen = React.lazy(()=> import('Components/ScootyStoresScreen'));
const FastStoresScreen = React.lazy(()=> import('Components/FastStoresScreen'));
const BafaloStoresScreen = React.lazy(()=>import('Components/BafaloStoresScreen'));
const CustomStoresScreen = React.lazy(()=>import('Components/CustomStoresScreen'));

@inject(store => {
    const { helperStore, myShopApiStore, ifaceMngr } = store;
    return { helperStore, myShopApiStore, ifaceMngr };
})

@observer
class Root extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            mainColor: 'gray',
            noInternetModalOpen: false,
            // selectedStore: null,
            // storeOpened: false
        }
    }

    setLoading = () => {
        this.setState(prevState => ({
            loading: !prevState.loading
        }));
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    testInit = async () => {
        if ( this.props.helperStore.init ) {
            return true;
        }
        else {
            console.log('waiting...');
            await this.sleep(500);
            await this.testInit();
        }
    }
    shopInit = async () => {
        if ( this.props.myShopApiStore.init ) {
            return true;
        }
        else {
            console.log('waiting...');
            await this.sleep(500);
            await this.shopInit();
        }
    }
    logout = () => {
        this.setLoading();
        // this.props.groupeeApiStore.resetAll();
        // this.props.accountKitStore.resetAll();
        this.props.myShopApiStore.resetAll();
        setTimeout(() => {
            this.setLoading();
        }, 500);
    }

    preloadImages = () => {
        // [
        //     'assets/welcome_bg_top.png'
        // ].forEach(image => {
        //     new Image().src = image;
        // });
        new Image().src = welcomeShopImage;
    }

    componentDidMount() {
        //const { getShopsResp, getApiResp_SetShop, setShopId, setShopName, shopsData, closeStore } = this.props.myShopApiStore;
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);

        cssVars();
        ////////////////////////for single store!!!!! //////////////
        //await getShopsResp()
        const { shop, shopId, isSingleStore, getShopsResp } = this.props.myShopApiStore;

        this.preloadImages();


        //isSingleStore && openStore(shopId, shop ? shop.name : "");// || (await getShopsResp() && console.count('get-shops'));

        ////////////////////////////////////////////////////////////
        
        //START AS MANY DOWNLOADS AS POSSIBLE FROM THE BEGINNING 
        getShopsResp();

        // console.log("store:", this.props.myShopApiStore.getStore());
        // await this.testInit();
        // await this.shopInit();
        //document.body.style.backgroundImage= this.props.myShopApiStore.setBodyBg();
        
        //if (!shopsData.shops?.length) await getApiResp_SetShop();
        this.setState({mainColor: this.props.myShopApiStore.mainColor});
    }

    componentWillUnmount() {
        // Remove event listeners
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    }

    handleOnline = () => {
        this.setState({ noInternetModalOpen: false });
        this.props.myShopApiStore.isOnline = true;
        this.props.myShopApiStore.getShopsResp();
    }

    handleOffline = () => {
        this.setState({ noInternetModalOpen: true });
        this.props.myShopApiStore.isOnline = false;
    }

    customScreen = {
        toskana: ToskanaStoresScreen, 
        fast: FastStoresScreen, 
        scooty: ScootyStoresScreen, 
        bafalo: BafaloStoresScreen,
        custom: CustomStoresScreen,
        default: StoresScreen
    }

    componentDidUpdate = (prevProps, prevState) => {
        // if(this.props.myShopApiStore.shopId !== prevProps.myShopApiStore.shopId) 
    }

    render() {
        const { shopsData, storeOpened, isSingleStore, ShopsListType, shopId } = this.props.myShopApiStore;
        const ShopsList = this.customScreen[ShopsListType];
        
        //console.log("Root -> render -> isSingle", isSingleStore, "storeOpened", storeOpened)

        return(
            <Suspense fallback ={<div>Loading ...</div>}>
                <NoInternetModal 
                    modalIsOpen={this.state.noInternetModalOpen}
                    closeModal={() => {
                        if (navigator.onLine) {
                            this.setState({ noInternetModalOpen: false });
                            this.props.myShopApiStore.isOnline = true;
                        }
                    }}
                    shouldCloseOnOverlayClick={false}
                    shouldCloseOnEsc={false}
                />
                {
                    isSingleStore || storeOpened //true || shopsData === {}//isSingleStore
                    ?   <MainScreen mainColor={this.mainColor}/>
                    :   (!!shopsData?.shops.length &&                
                            <ShopsList />)
                }
            </Suspense>
        )
    }
}

export default Root;

